module.exports = __webpack_public_path__ + "img/select.4f2c7019.svg";